import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconPlus = ({ color = 'currentColor', size = 'micro', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" size={size} {...props}>
        <StyledPath color={color} d="M6.375 10.5V6.375h3.875V4.75H6.375V.625h-1.75V4.75H.75v1.625h3.875V10.5z" />
    </StyledSvg>
);
